import { getDay } from 'date-fns'
import ru from 'date-fns/locale/ru'
import { registerLocale } from 'react-datepicker'
import Input from 'ui/components/forms/Input/'
import { DatePickerStyled } from './styled'

registerLocale('ru', ru)

const DatepickerInput = ({
  disableWeekends,
  selected,
  onChange,
  onFocus,
  onKeyDown,
  onClickOutside,
  onInputClick,
  ...restProps
}) => {
  const isWeekday = (date) => {
    if (disableWeekends) {
      const day = getDay(date)
      return day !== 0 && day !== 6
    }

    return true
  }

  const handleKeyDown = (event) => {
    if (event.code === 'Escape') {
      event.stopPropagation()
      return
    }

    onKeyDown?.(event)
  }

  const handleFocus = (event) => {
    const input = event.currentTarget

    input.addEventListener(
      'blur',
      () => {
        setTimeout(() => {
          const popper = document.querySelector('.react-datepicker-popper')
          const isFocusInsideCalendar = popper?.contains(document.activeElement)

          if (!isFocusInsideCalendar) {
            input.closest('.react-datepicker-wrapper')?.dispatchEvent(
              new MouseEvent('mousedown', {
                bubbles: true,
              })
            )
          }
        })
      },
      { once: true }
    )

    onFocus?.(event)
  }

  return (
    <DatePickerStyled
      {...restProps}
      locale="ru"
      dateFormat="dd.MM.yyyy"
      selected={selected}
      onChange={onChange}
      filterDate={isWeekday}
      onKeyDown={handleKeyDown}
      onFocus={handleFocus}
      onClickOutside={onClickOutside}
      onInputClick={onInputClick}
      customInput={<Input {...restProps} />}
    />
  )
}

export default DatepickerInput
